import { UserRoles } from '@/types/user/user_roles'
import { Response } from '@/types/v2'
import {
  CreateUserBodyRequest,
  CreateUserBodyResponse,
  DealerAdmin,
  RoleByUserLogged,
  TUpdateUser,
  UserDetails,
} from '@/types/v2/settings/users'
import axios from 'axios'
import nookies from 'nookies'

const api_url = process.env.NEXT_PUBLIC_API_URL

let config = {}
const token = nookies.get(null, 'session')
if (token) {
  config = {
    headers: {
      Authorization: 'Bearer ' + token.session,
    },
  }
}
export interface UserListResponse {
  page_size: number
  page_number: number
  sort_column: string
  registry_count: number
  search_text: string
  list: UserListItem[]
  sort: string
  filters: string[]
}
export interface UserListItem {
  phone_number: ''
  full_name: string
  role_names: string[]
  role_ids: UserRoles[]
  id: number
  company_names: string[]
  email: string
  status: string
  last_log_in_date: string
}

export const getUserList = async (queryString: string): Promise<UserListResponse> => {
  const response = await axios.get(`${api_url}/users?${queryString}`)
  const { data } = response.data
  return data
}

const getUsers = async (params: string, controller: AbortController): Promise<any> => {
  const url = `${api_url}/users/${params || ''}`

  const { data } = await axios.get(url, {
    ...config,
    signal: controller.signal,
  })
  return data
}

const getCustomers = async (params: string, controller: AbortController): Promise<any> => {
  const url = `${api_url}/customers/${params || ''}`

  const { data } = await axios.get(url, {
    ...config,
    signal: controller.signal,
  })
  return data
}

export const updateUser = async (id: number, requestData: TUpdateUser): Promise<string> => {
  const { data } = await axios.put<Response<string>>(`${api_url}/users/${id}`, requestData, config)
  return data.message
}

const getStatus = async (): Promise<any> => {
  const { data } = await axios.get(api_url + `/users/status/`, config)
  return data
}

const getTypeUsers = async (): Promise<any> => {
  const { data } = await axios.get(api_url + `/users/types/`, config)
  return data
}

const getSendVerificationEmail = async (id: number): Promise<string> => {
  const { data: axiosData } = await axios.get<Response<string>>(
    api_url + `/users/${id}/send-validation-email`,
    config
  )
  return axiosData.message
}

const getPermissions = async (): Promise<any> => {
  const { data } = await axios.get(api_url + `/authorization/permissions`, config)
  return data
}

const getRolesByUserLogged = async (): Promise<RoleByUserLogged[]> => {
  const { data: axiosResponse } = await axios.get<Response<RoleByUserLogged[]>>(
    `${api_url}/users/createable-roles`,
    config
  )
  return axiosResponse.data
}

const getDealerAdminsByManufacturer = async (manufCompanyId: string): Promise<DealerAdmin[]> => {
  const { data: axiosResponse } = await axios.get<Response<DealerAdmin[]>>(
    `${api_url}/users/manufacturer-dealer-admins?manufacturer_company_id=${manufCompanyId}`,
    config
  )
  return axiosResponse.data
}

const postCreateUser = async (requestData: CreateUserBodyRequest): Promise<Response<CreateUserBodyResponse>> => {
  const { data: axiosResponse } = await axios.post<Response<CreateUserBodyResponse>>(
    `${api_url}/users/`,
    requestData,
    config
  )
  return axiosResponse
}

const getUser = async (id: string): Promise<UserDetails> => {
  const { data: axiosData } = await axios.get<Response<UserDetails>>(`${api_url}/users/${id}/`, config)
  return axiosData.data
}

const getDealerAddress = async (id: string): Promise<any> => {
  const response = await axios.get<Response<any>>(`${api_url}/users/dealer/${id}/`, config)
  return response
}
 
const updateDealerDetails = async (requestData:any,id: string): Promise<any> => {
  const { data: axiosData } = await axios.put(`${api_url}/users/update/dealer/${id}/`, requestData,config)
  return axiosData.data
}

const revertUserRole = async(requestData:any):Promise<any>=>{
  const {data: axiosData} = await axios.put(`${api_url}/users/revert/user/role`,requestData,config)
  return axiosData.data
}

export default {
  getUsers,
  getCustomers,
  getUser,
  postCreateUser,
  updateUser,
  getStatus,
  getTypeUsers,
  getSendVerificationEmail,
  getPermissions,
  getRolesByUserLogged,
  getDealerAdminsByManufacturer,
  getUserList,
  updateDealerDetails,
  getDealerAddress,
  revertUserRole
}
